import React from 'react';

var CloneWarningPopup = React.createClass({
	handleCloseClick: function(){
		this.props.cloneWarning("close");
	},
	stopPorpagation: function(e){
		e.stopPropagation();
	},
	render: function(){
		return(
			<div className="modal__mask" onClick= {this.handleCloseClick}> 
				<div className="modal__content modal--md" onClick = {this.stopPorpagation}>
				  <div className="modal__header">
				    <h3 className="modal__header--title">Warning: Account Upgrade Required</h3>
				    <a href="javascript:void(0)" className="modal__close" onClick= {this.handleCloseClick}>
				    	<i className="fa  fa-close"> </i>
				    </a> 
				  </div>
				  <div className="modal__body clearfix">
				    <div className="form__row clearfix">
				      <p>Package <strong>"{this.props.slug}"</strong> has been added to your local Design Library, but has not been sent to the Hub. In order to sync to the Hub, you'll have to upgrade your account to allow for additional private packages. After you've upgraded, simply push the package to complete the clone process. </p>
				    </div>
				    <div className="buttons clearfix">
				      <button className="btn__lg bg-bright" onClick= {this.handleCloseClick}>Ok</button>
				    </div>
				  </div>
				</div>
			</div>
		);
	}
});

export {CloneWarningPopup};


/** WEBPACK FOOTER **
 ** ./html/components/DetailsPage/CloneWarningPopup.jsx
 **/